import styled from 'styled-components';

export const CloseIcon = styled.img`
  width: 14px;
  align-self: flex-end;
  cursor: pointer;
`;

export const HeaderLine = styled.div`
  content: '';
  flex: 1;
  height: 1px;
  background-color: #4948ac;
  align-self: center;
`;

export const DependentsForm = styled.form`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  justify-content: center;
`;

export const DependentsForms = styled.form`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  justify-content: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 30px;
  opacity: 1;
`;

export const FormInputWrapper = styled.div`
  flex: 0 0 calc(33.33% - 20px);
  max-height: 75px;
  p {
    margin: 2px;
  }
  input {
    border: 0.5px solid #222247;
    border-radius: 7px;
    opacity: 1;
  }
  input: disabled {
    background: F3F4F8;
  }
  select {
    border: 0.5px solid #222247;
    border-radius: 7px;
    opacity: 1;
  }
`;

export const HeadingShow = styled.div`
  margin-bottom: 1.5%;
  display: flex;
  font: normal normal 600 28px/32px Biotif;
  letter-spacing: -0.33px;
`;

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  width: 100%;
`;

export const WarningEditMessage = styled.p`
  flex: auto;
  margin-left: 3%
  color : red;
`;
